module.exports = __webpack_public_path__ + "img/SEJ enventos_Circulos Login.b2e0d959.svg";